import { ShiftInviteStatus } from "@clipboard-health/contract-backend-main";
import { Pill } from "@clipboard-health/ui-components";
import { type Theme } from "@mui/material";
import { Box } from "@mui/material";

import { getShiftInviteExpirationText } from "./utils";

interface ShiftInviteStatusPillProps {
  status: ShiftInviteStatus;
  expiresAt: Date;
  currentDate: Date;
  disabled?: boolean;
}

export function ShiftInviteStatusPill(props: ShiftInviteStatusPillProps) {
  const { status, expiresAt, currentDate, disabled } = props;

  const STATUS_LABELS: Record<ShiftInviteStatus, string> = {
    [ShiftInviteStatus.ACCEPTED]: "Invite accepted",
    [ShiftInviteStatus.DECLINED]: "Invite declined",
    [ShiftInviteStatus.PENDING]: getShiftInviteExpirationText(expiresAt, currentDate),
    [ShiftInviteStatus.EXPIRED]: "Invite expired",
    [ShiftInviteStatus.DELETED]: "", // Not used
  };

  const color = (theme: Theme) => {
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch (status) {
      case ShiftInviteStatus.ACCEPTED: {
        return theme.palette.intent?.success.text;
      }

      case ShiftInviteStatus.DECLINED:
      case ShiftInviteStatus.PENDING: {
        return theme.palette.intent?.error.text;
      }

      default: {
        return theme.palette.text.primary;
      }
    }
  };

  const outlineColor = (theme: Theme) => {
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch (status) {
      case ShiftInviteStatus.ACCEPTED: {
        return theme.palette.intent?.success.text;
      }

      case ShiftInviteStatus.DECLINED:
      case ShiftInviteStatus.PENDING: {
        return theme.palette.intent?.error.border;
      }

      default: {
        return theme.palette.border?.primary;
      }
    }
  };

  return (
    <>
      <Pill
        key="shift-invite-status"
        variant="outlined"
        size="small"
        label={STATUS_LABELS[status]}
        color={color}
        outlineColor={outlineColor}
        backgroundColor={(theme) => theme.palette.background.quaternary}
        sx={{ zIndex: 3 }}
      />
      {disabled && (
        // use Box overlay to achieve disabled text affect on ShiftInviteCard
        <Box
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 2,
          }}
        />
      )}
    </>
  );
}
